// Translation service based on the original Python implementation

// Import locale files
import enTranslations from '../../locales/en.json';
import esEsTranslations from '../../locales/es-es.json';
import esMxTranslations from '../../locales/es-mx.json';
import esArTranslations from '../../locales/es-ar.json';
import esCoTranslations from '../../locales/es-co.json';
import esPeTranslations from '../../locales/es-pe.json';
import deTranslations from '../../locales/de.json';
import frTranslations from '../../locales/fr.json';
import itTranslations from '../../locales/it.json';
import ptTranslations from '../../locales/pt.json';
import ptPtTranslations from '../../locales/pt-pt.json';
import jaTranslations from '../../locales/ja.json';

export interface Translations {
  'apply.new_opportunity': string;
  'apply.title': string;
  'apply.form_title': string;
  'apply.referral_form_title': string;
  'apply.referral_first_name': string;
  'apply.referral_last_name': string;
  'apply.referral_phone': string;
  'apply.referral_email': string;
  'apply.full_name': string;
  'apply.last_name': string;
  'apply.email': string;
  'apply.phone': string;
  'apply.phone_invalid': string;
  'apply.cv': string;
  'apply.cv_drop': string;
  'apply.cv_image_warning': string;
  'apply.cv_formats': string;
  'apply.skills': string;
  'apply.back': string;
  'apply.form_eyebrow': string;
  'apply.submit': string;
  'apply.loading': string;
  'apply.position_not_found': string;
  'apply.submitting': string;
  'apply.verifying': string;
  'apply.already_applied': string;
  'apply.success_title': string;
  'apply.success_message': string;
  'apply.success_already_applied_message': string;
  'apply.referral_success_title': string;
  'apply.referral_success_message': string;
  'apply.referral_refer_another': string;
  'apply.company_name': string;
  'apply.company_description': string;
  'apply.open_questions': string;
  'apply.required_questions': string;
  'apply.privacy_policy': string;
  'apply.privacy_policy_link': string;
  'apply.privacy_and_tos_connector': string;
  'apply.terms_of_service_link': string;
  'apply.contact_consent': string;
  'apply.contact_consent_link': string;
  'apply.manager_informed': string;
  'apply.sms_consent': string;
  'apply.sms_consent_link': string;
  'apply.sms_consent_optional': string;
  'apply.optional': string;
  'apply.no_logo': string;
  'apply.join_date_label': string;
  'apply.error_cv_required': string;
  'apply.error_invalid_phone': string;
  'apply.error_source_required': string;
  'apply.error_form': string;
  'apply.error_network': string;
  'apply.source_label': string;
  'apply.source_placeholder': string;
  'apply.employee_id': string;
  'apply.employee_id_hint': string;
  'apply.referrer_name': string;
  'apply.referrer_national_id': string;
  'apply.referred_by': string;
  'apply.referred_by_hint': string;
  'apply.documents': string;
  'apply.documents_drop': string;
  'apply.yes': string;
  'apply.no': string;
  'apply.select_placeholder': string;
  'apply.url_placeholder': string;
  'apply.other_option': string;
  'career_site.title': string;
  'career_site.search_placeholder': string;
  'career_site.all_locations': string;
  'career_site.all_contract_types': string;
  'career_site.all_attribute': string;
  'career_site.all_work_site': string;
  'career_site.all_teams': string;
  'career_site.contract_type.full_time': string;
  'career_site.contract_type.part_time': string;
  'career_site.contract_type.freelance': string;
  'career_site.contract_type.temporary': string;
  'career_site.contract_type.internship': string;
  'career_site.contract_type.permanent': string;
  'career_site.contract_type.fixed_term': string;
  'career_site.contract_type.other': string;
  'career_site.no_results': string;
  'career_site.loading': string;
  'career_site.not_found': string;
  'career_site.not_found_message': string;
  'career_site.about': string;
  'career_site.about_subtitle': string;
  'career_site.back': string;
  'career_site.open_applications': string;
  'career_site.open_applications_subtitle': string;
  'career_site.open_roles': string;
  'career_site.roles_one': string;
  'career_site.roles_other': string;
  'career_site.internal_banner_title': string;
  'career_site.internal_banner_description': string;
  'career_site.internal_banner_link': string;
  'career_site.internal_verify_title': string;
  'career_site.internal_verify_email_label': string;
  'career_site.internal_verify_email_placeholder': string;
  'career_site.internal_verify_email_submit': string;
  'career_site.internal_verify_otp_sent': string;
  'career_site.internal_verify_otp_label': string;
  'career_site.internal_verify_otp_placeholder': string;
  'career_site.internal_verify_otp_submit': string;
  'career_site.internal_verify_otp_resend': string;
  'career_site.internal_verify_otp_back': string;
  'career_site.referral_banner_title': string;
  'career_site.referral_banner_description': string;
  'career_site.skip_to_content': string;
  'career_site.menu': string;
  'career_site.menu_open': string;
  'career_site.menu_close': string;
  'career_site.countries': string;
  'career_site.home': string;
  'career_site.show_more': string;
  'career_site.featured_positions': string;
  'career_site.page_not_found': string;
  'career_site.page_not_found_message': string;
  'career_site.preview_badge': string;
  'career_site.block_error': string;
  'career_site.video': string;
  'career_site.video_play': string;
  'career_site.video_close': string;
  'career_site.sign_out': string;
  'career_site.signed_in_as': string;
  'career_site.internal_verify_too_many_attempts': string;
  'career_site.internal_verify_invalid_code': string;
  'career_site.internal_verify_error': string;
  'career_site.internal_verify_tenant_hint': string;
  'career_site.portal_not_available': string;
  'privacy_policy.title': string;
  'privacy_policy.not_available': string;
  'privacy_policy.not_found': string;
  'privacy_policy.back': string;
  'privacy_policy.back_to_careers': string;
  'terms_of_service.title': string;
  'terms_of_service.not_available': string;
  'terms_of_service.not_found': string;
  'terms_of_service.back': string;
  'terms_of_service.back_to_careers': string;
  'maintenance.title': string;
  'maintenance.message1': string;
  'maintenance.message2': string;
  'error.generic': string;
  'not_found.title': string;
  'candidate_link.secure_upload': string;
  'candidate_link.title': string;
  'candidate_link.intro': string;
  'candidate_link.template_download': string;
  'candidate_link.template_hint': string;
  'candidate_link.sent_so_far': string;
  'candidate_link.sent': string;
  'candidate_link.sending': string;
  'candidate_link.add_more': string;
  'candidate_link.choose_files': string;
  'candidate_link.file_hint': string;
  'candidate_link.consent_session': string;
  'candidate_link.consent_legacy': string;
  'candidate_link.privacy_notice_link': string;
  'candidate_link.privacy_notice_end': string;
  'candidate_link.error_verify': string;
  'candidate_link.error_send': string;
  'candidate_link.expired_title': string;
  'candidate_link.expired_sent': string;
  'candidate_link.expired_limit': string;
  'candidate_link.expired_offer': string;
  'candidate_link.expired_failed': string;
  'candidate_link.expired_sending': string;
  'candidate_link.expired_button': string;
  'candidate_link.privacy_title': string;
  'candidate_link.privacy_p1': string;
  'candidate_link.privacy_p2': string;
}

const translations: Record<string, Translations> = {
  'en': enTranslations,
  'es-es': esEsTranslations,
  'es-mx': esMxTranslations,
  'es-ar': esArTranslations,
  'es-co': esCoTranslations,
  'es-pe': esPeTranslations,
  'de': deTranslations,
  'fr': frTranslations,
  'it': itTranslations,
  'pt': ptTranslations,
  'pt-pt': ptPtTranslations,
  'ja': jaTranslations,
};

function findTranslations(language: string): Translations | undefined {
  const langKey = language.toLowerCase();
  if (translations[langKey]) {
    return translations[langKey];
  }

  // Try base language (e.g. "en-us" -> "en", "es" -> "es")
  const baseLang = langKey.split('-')[0];
  if (translations[baseLang]) {
    return translations[baseLang];
  }

  // Try base language with common region (e.g. "es" -> "es-es")
  return translations[`${baseLang}-${baseLang}`];
}

/**
 * Get translations for the specified language
 * Based on the original Python get_translations function
 */
export function getTranslations(language: string): Translations {
  try {
    // Fallback to English if language not found
    return findTranslations(language) ?? translations['en'];
  } catch (error) {
    console.warn(`Failed to load translations for language: ${language}`, error);
    return translations['en'];
  }
}

/**
 * The first candidate language the site has a translation for, else English.
 * Catalan resolves to es-es.
 * Unlike getTranslations, an unsupported language is skipped rather than
 * treated as the answer, so a later candidate can still be used.
 */
export function resolveLanguage(...candidates: Array<string | null | undefined>): string {
  for (const candidate of candidates) {
    if (typeof candidate !== 'string' || !candidate) continue;
    // The site has no Catalan locale; Spanish is the closest it offers.
    if (/^ca(-|$)/i.test(candidate)) return 'es-es';
    if (findTranslations(candidate)) return candidate;
  }
  return 'en';
}

/**
 * Get translation with fallback
 */
export function t(key: keyof Translations, language: string = 'es-es'): string {
  const translations = getTranslations(language);
  return translations[key] || key;
}
